// extracted by mini-css-extract-plugin
export default {"root":"ErrorFallback_root__Aeas3","errorText":"ErrorFallback_errorText__bPJHv"};